"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateBakers = exports.asBaker = exports.useRandomBaker = exports.useBaker = exports.useDelegation = exports.loadAccountDelegation = exports.loadBaker = exports.isAccountDelegating = exports.getAccountDelegationSync = exports.getBakerSync = exports.useBakers = exports.listBakers = exports.fetchAllBakers = void 0;
const cache_1 = require("@ledgerhq/live-network/cache");
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const logs_1 = require("@ledgerhq/logs");
const react_1 = require("react");
const live_env_1 = require("@ledgerhq/live-env");
const capacityStatuses = {
    normal: null,
    full: null,
};
const cache = (0, cache_1.makeLRUCache)(() => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, live_env_1.getEnv)("API_TEZOS_BAKER");
    const { data, } = yield (0, network_1.default)({
        url: `${base}/v2/bakers`,
    });
    const bakers = [];
    if (data && typeof data === "object" && Array.isArray(data)) {
        (0, logs_1.log)("tezos/bakers", "found " + data.length + " bakers");
        data
            .filter(raw => raw.serviceHealth === "active")
            .forEach(raw => {
            const baker = (0, exports.asBaker)(raw);
            if (baker) {
                bakers.push(baker);
            }
        });
    }
    (0, logs_1.log)("tezos/bakers", "loaded " + bakers.length + " bakers");
    return bakers;
}), () => "");
let _lastBakers;
const fetchAllBakers = () => __awaiter(void 0, void 0, void 0, function* () {
    const r = yield cache.force();
    _lastBakers = r;
    return r;
});
exports.fetchAllBakers = fetchAllBakers;
function whitelist(all, addresses) {
    const map = {};
    all.forEach(b => {
        map[b.address] = b;
    });
    return addresses.map(addr => map[addr]).filter(Boolean);
}
const listBakers = (whitelistAddresses) => __awaiter(void 0, void 0, void 0, function* () {
    const all = yield cache();
    _lastBakers = all;
    return whitelist(all, whitelistAddresses);
});
exports.listBakers = listBakers;
function useBakers(whitelistAddresses) {
    const [bakers, setBakers] = (0, react_1.useState)(() => whitelist(_lastBakers || [], whitelistAddresses));
    (0, react_1.useEffect)(() => {
        let cancelled;
        (0, exports.listBakers)(whitelistAddresses).then(bakers => {
            if (cancelled)
                return;
            setBakers(bakers);
        });
        return () => {
            cancelled = true;
        };
    }, [whitelistAddresses]);
    return bakers;
}
exports.useBakers = useBakers;
function getBakerSync(addr) {
    if (_lastBakers) {
        return _lastBakers.find(baker => baker.address === addr);
    }
}
exports.getBakerSync = getBakerSync;
function getAccountDelegationSync(account) {
    const op = account.operations.find(op => !op.hasFailed && (op.type === "DELEGATE" || op.type === "UNDELEGATE"));
    const pendingOp = account.pendingOperations
        .filter(op => !account.operations.some(o => op.hash === o.hash))
        .find(op => op.type === "DELEGATE" || op.type === "UNDELEGATE");
    const isPending = !!pendingOp;
    const operation = pendingOp && pendingOp.type === "DELEGATE" ? pendingOp : op;
    if (!operation || operation.type === "UNDELEGATE") {
        return null;
    }
    const recentOps = account.operations
        .filter(op => op.date > operation.date)
        .concat(account.pendingOperations);
    const sendShouldWarnDelegation = !recentOps.some(op => op.type === "OUT");
    const receiveShouldWarnDelegation = !recentOps.some(op => op.type === "IN");
    return {
        isPending,
        operation,
        address: operation.recipients[0],
        baker: null,
        sendShouldWarnDelegation,
        receiveShouldWarnDelegation,
    };
}
exports.getAccountDelegationSync = getAccountDelegationSync;
function isAccountDelegating(account) {
    return !!getAccountDelegationSync(account);
}
exports.isAccountDelegating = isAccountDelegating;
function loadBaker(addr) {
    return __awaiter(this, void 0, void 0, function* () {
        const cacheBaker = getBakerSync(addr);
        if (cacheBaker)
            return Promise.resolve(cacheBaker);
        const bakers = yield cache();
        const baker = bakers.find(baker => baker.address === addr);
        return baker;
    });
}
exports.loadBaker = loadBaker;
function loadAccountDelegation(account) {
    return __awaiter(this, void 0, void 0, function* () {
        const d = getAccountDelegationSync(account);
        if (!d)
            return Promise.resolve(null);
        const baker = yield loadBaker(d.address);
        return Object.assign(Object.assign({}, d), { baker });
    });
}
exports.loadAccountDelegation = loadAccountDelegation;
function useDelegation(account) {
    const [delegation, setDelegation] = (0, react_1.useState)(() => getAccountDelegationSync(account));
    (0, react_1.useEffect)(() => {
        let cancelled;
        loadAccountDelegation(account).then(delegation => {
            if (cancelled)
                return;
            setDelegation(delegation);
        });
        return () => {
            cancelled = true;
        };
    }, [account]);
    return delegation;
}
exports.useDelegation = useDelegation;
function useBaker(addr) {
    const [baker, setBaker] = (0, react_1.useState)(() => getBakerSync(addr));
    (0, react_1.useEffect)(() => {
        let cancelled;
        loadBaker(addr).then(baker => {
            if (cancelled)
                return;
            setBaker(baker);
        });
        return () => {
            cancelled = true;
        };
    }, [addr]);
    return baker;
}
exports.useBaker = useBaker;
//  select a random baker for the mount time (assuming bakers length don't change)
function useRandomBaker(bakers) {
    const randomBakerIndex = (0, react_1.useMemo)(() => {
        const nonFullBakers = bakers.filter(b => b.capacityStatus !== "full");
        if (nonFullBakers.length > 0) {
            // if there are non full bakers, we pick one
            const i = Math.floor(Math.random() * nonFullBakers.length);
            return bakers.indexOf(nonFullBakers[i]);
        }
        // fallback on random between only full bakers
        return Math.floor(Math.random() * bakers.length); // for perf, we only want to re-calc on bakers.length changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bakers.length]);
    return bakers[randomBakerIndex];
}
exports.useRandomBaker = useRandomBaker;
const asBaker = (data) => {
    if (data && typeof data === "object") {
        const { address, name, logo, freeSpace, estimatedRoi } = data;
        if (typeof name === "string" &&
            typeof address === "string" &&
            typeof logo === "string" &&
            (logo.startsWith("https://") || logo.startsWith("http://")) &&
            typeof freeSpace === "number" &&
            typeof estimatedRoi === "number" &&
            0 <= estimatedRoi &&
            estimatedRoi <= 1) {
            return {
                name,
                address,
                logoURL: logo,
                nominalYield: Math.floor(10000 * estimatedRoi) / 100 + " %",
                capacityStatus: freeSpace <= 0 ? "full" : "normal",
            };
        }
    }
};
exports.asBaker = asBaker;
const hydrateBakers = (bakers) => {
    (0, logs_1.log)("tezos/bakers", "hydrate " + bakers.length + " bakers");
    cache.hydrate("", bakers);
};
exports.hydrateBakers = hydrateBakers;
//# sourceMappingURL=bakers.js.map